import "../../../styles/components/skeleton/_skeleton.scss";

// 0018: base skeleton box. Purely presentational (aria-hidden) loading placeholder.
//  - variant: "text" | "rect" | "rounded" | "circle" — shape/border-radius.
//  - width / height: any CSS size (string or number → px). For "rect" pass an explicit size.
//  - count: render N stacked boxes (e.g. text lines).
//  - className / style: extra styling for variant wrappers to size cells.
const Skeleton = ({ variant = "text", width, height, count = 1, className = "", style = {} }) => {
  const boxStyle = { ...style };
  if (width !== undefined) boxStyle.width = width;
  if (height !== undefined) boxStyle.height = height;

  const boxes = Array.from({ length: Math.max(1, count) }, (_, index) => (
    <span key={index} className={`skeleton skeleton--${variant} ${className}`.trim()} style={boxStyle} aria-hidden="true" />
  ));

  return count > 1 ? <>{boxes}</> : boxes[0];
};

export default Skeleton;
